import { Box, Stack, Typography } from "@mui/material"
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import CloseIcon from '@mui/icons-material/Close'
import OpcaoCard from "../../components/opcao-card"

interface CpfPerguntaProps {
    onInformar: () => void
    onPular: () => void
}

export default function CpfPergunta({ onInformar, onPular }: CpfPerguntaProps): JSX.Element {
    return (
        <Stack spacing={4} sx={{ alignItems: 'center', width: '100%' }}>
            <Typography variant="h4" color="text.secondary" sx={{ fontWeight: 'bold' }}>
                Deseja incluir CPF na nota fiscal?
            </Typography>

            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 3, width: '100%', maxWidth: 620 }}>
                <OpcaoCard
                    icone={<HowToRegOutlinedIcon sx={{ fontSize: 64, color: 'success.main' }} />}
                    rotulo="Sim, informar CPF"
                    onClick={onInformar}
                />

                <OpcaoCard
                    icone={<CloseIcon sx={{ fontSize: 64, color: 'error.main' }} />}
                    rotulo="Não"
                    onClick={onPular}
                />
            </Box>
        </Stack>
    )
}